import React from 'react';

const styles = {
  page: {
    width: '210mm',
    height: '297mm',
    background: 'white',
    position: 'relative',
    fontFamily: 'Arial, sans-serif',
    fontSize: '12px',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '24px 24px 8px',
  },
  logoWrap: { width: '120px' },
  logo: { height: '64px', objectFit: 'contain' },
  banner: {
    background: 'linear-gradient(to right, #9ca3af, #6b7280, #22c55e)',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '12px 0 0 12px',
  },
  bannerTitle: { fontSize: '18px', fontWeight: 700 },
  bannerText: { fontSize: '12px', marginTop: '4px' },
  body: {
    padding: '0 32px',
    marginTop: '16px',
  },
  sectionBox: {
    border: '2px solid #000',
    marginBottom: '18px',
  },
  sectionHeader: {
    background: '#f3f4f6',
    padding: '6px 10px',
    borderBottom: '1px solid #000',
    textAlign: 'center',
    fontWeight: 700,
  },
  paragraph: {
    padding: '10px',
    fontSize: '12px',
  },
  badgeBlue: {
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    borderRadius: '6px',
    padding: '8px',
    fontSize: '11px',
    marginTop: '8px',
  },
  badgeAmber: {
    background: '#fffbeb',
    border: '1px solid #fcd34d',
    borderRadius: '6px',
    padding: '8px',
    fontSize: '11px',
    marginTop: '8px',
  },
  badgeSlate: {
    background: '#f8fafc',
    border: '1px solid #cbd5e1',
    borderRadius: '6px',
    padding: '8px',
    fontSize: '11px',
    marginTop: '8px',
  },
  footer: {
    position: 'absolute',
    bottom: '16px',
    left: 0,
    right: 0,
    padding: '0 32px',
    fontSize: '10px',
    color: '#6b7280',
  },
  footerLine: {
    borderTop: '1px solid #cbd5e1',
    paddingTop: '6px',
    textAlign: 'center',
  },
  footerRight: {
    textAlign: 'right',
    marginTop: '4px',
  },
};

export default function Page3DocumentationEssais({ rapport, client, parametres }) {
  const p = parametres || {};
  const c = client || {};
  const r = rapport || {};
  const etape5 = r.etape_5_documentation_essais_levage || {};
  const nomClient = c.entreprise || c.nom || `${c.prenom || ''} ${c.nom || ''}`.trim();

  return (
    <div style={styles.page} className="pdf-page">
      <div style={styles.headerRow}>
        <div style={styles.logoWrap}>
          {p.company_logo_url && <img src={p.company_logo_url} alt="Logo" style={styles.logo} />}
        </div>
        <div style={styles.banner}>
          <div style={styles.bannerTitle}>Vérification générale périodique</div>
          <div style={styles.bannerText}><strong>Client : {nomClient}</strong></div>
          <div style={styles.bannerText}>{c.adresse}</div>
          <div style={styles.bannerText}>{c.code_postal} {c.ville}</div>
          <div style={{ ...styles.bannerText, marginTop: '6px' }}>
            <strong>Rapport de vérification : {r.numero_rapport}</strong>
          </div>
        </div>
      </div>

      <div style={styles.body}>
        <div style={styles.sectionBox}>
          <div style={styles.sectionHeader}>RÉALISATION DES ESSAIS</div>
          <div style={styles.paragraph}>
            <p style={{ textAlign: 'center', marginBottom: '8px' }}>
              Les essais ont été réalisés avec une charge de <strong>{etape5.charge_essai || '_____'}</strong> Kg
            </p>
            {etape5.essais_equipements_presentes && (
              <div style={styles.badgeBlue}>
                Les essais de fonctionnement ont été réalisés avec les équipements présentés lors de la visite
              </div>
            )}
            {etape5.phrase_supplementaire && (
              <div style={styles.badgeAmber}>
                Les essais ont été réalisés avec les charges mises à disposition. 
                Le chef d'établissement doit prendre les dispositions visant à restreindre 
                l'utilisation de l'équipement à cette charge ou faire procéder à de nouveaux 
                essais sous charge nominale.
              </div>
            )}
            {etape5.precisions_essais && (
              <div style={styles.badgeSlate}>
                <strong>Précisions : </strong>{etape5.precisions_essais}
              </div>
            )}
          </div>
        </div>

        <div style={styles.sectionBox}>
          <div style={{ ...styles.sectionHeader, color: '#b91c1c' }}>
            ANOMALIES CONSTATÉES LORS DE LA VÉRIFICATION
          </div>
          <div style={{ ...styles.paragraph, minHeight: '200px' }}>
            {etape5.appareil_non_controle ? (
              <div style={{ background: '#fee2e2', border: '2px solid #ef4444', borderRadius: '6px', padding: '10px' }}>
                <div style={{ fontWeight: 700, color: '#7f1d1d', marginBottom: '6px' }}>⚠️ APPAREIL NON CONTRÔLÉ</div>
                <div style={{ color: '#991b1b' }}>
                  <strong>Motif : </strong>
                  {etape5.motif_non_controle === 'immobilise' && 'Appareil immobilisé'}
                  {etape5.motif_non_controle === 'panne' && 'Appareil en panne'}
                  {etape5.motif_non_controle === 'conditions_securite' && "Les conditions d'essai en sécurité ne sont pas réunies"}
                  {etape5.motif_non_controle === 'non_presente' && 'Machine non présentée'}
                </div>
                {etape5.motif_non_controle_autre && (
                  <div style={{ color: '#b91c1c', fontStyle: 'italic', marginTop: '6px' }}>
                    {etape5.motif_non_controle_autre}
                  </div>
                )}
              </div>
            ) : etape5.anomalies ? (
              <div style={{ whiteSpace: 'pre-line' }}>{etape5.anomalies}</div>
            ) : (
              r.etape_11_observations?.observations?.map((obs, index) => (
                <div key={index} style={{ marginBottom: '6px' }}>
                  <span style={{ fontWeight: 700, color: '#b91c1c' }}>
                    {obs.element_ref?.section_titre ? `${obs.element_ref.section_titre} - ` : ''}
                    Point {obs.element_ref?.point_numero || obs.element?.replace('Point ', '')}
                  </span>
                  {' : '}
                  {obs.constat}
                </div>
              ))
            )}
            {!etape5.appareil_non_controle && !etape5.anomalies && (!r.etape_11_observations?.observations || r.etape_11_observations.observations.length === 0) && (
              <div style={{ color: '#6b7280', fontStyle: 'italic' }}>Aucune anomalie constatée</div>
            )}
          </div>
        </div>
      </div>

      <div style={styles.footer}>
        <div style={styles.footerLine}>
          <div>{p.company_name} - {p.legal_form} au capital de {p.capital}</div>
          <div>N° Siret : {p.siret_number} - R.C.S. {p.rcs_number} - Code APE : {p.ape_code}</div>
          <div style={styles.footerRight}>Page 3 / 6</div>
        </div>
      </div>
    </div>
  );
}
